import { RequestStatus } from "./TrackRequest/utils";

export type InactiveFolioLoginFormik = {
    userId: string;
    registerType: string;
    email: string;
    mobile: string;
};

export type GetInactiveFoliosRequestType = {
    pan: string;
    pekrn: string;
    reqId: string;
};

export type IndividualFolioSummaryType = {
    invName: string;
    amcName: string;
    amcUrl: string;
    rtaUrl: string;
};

export type IndividualFolioRequestType = {
    reqId: string;
    status: RequestStatus;
    data: Array<IndividualFolioSummaryType>;
};
export type GetInactiveFoliosResponseType = {
    body: {
        reqId: string;
        errors: Array<{ code: string; message: string; techMessage: string }>;
        success: Array<IndividualFolioRequestType>;
    };
};

export const InactiveFolioPaths = {
    LOGIN: '/inactive-folios',
    SEARCH: '/inactive-folios-search',
    TRACK_INTERMEDIATE: '/inactive-folios-go-track',
    TRACK: '/inactive-folios-track',
    SUMMARY: '/inactive-folios-summary',
}
